// Delete Code
export const DELETE_CODE_REQUEST = 'DELETE_CODE_REQUEST';
export const DELETE_CODE_DONE = 'DELETE_CODE_DONE';
export const DELETE_CODE_FAILED = 'DELETE_CODE_FAILED';
